import dayjs, { Dayjs } from 'dayjs';
import { InputBar } from '~/ui';
import { UserPromotionFormBoard } from './UserPromotionFormBoard/UserPromotionFormBoard';

import styles from './UserForm.module.scss';
import { useQuery } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';
import { useParams } from 'react-router-dom';
import { useToastError } from '~/utils/useToastError';
import { useEffect, useState } from 'react';
import { t } from 'i18next';

export const UserPromotionForm = () => {
  const { userID } = useParams();
  const toastError = useToastError();
  const [dates, setDates] = useState<[Dayjs, Dayjs]>([
    dayjs().subtract(1, 'week'),
    dayjs(),
  ]);
  const [sort, setSort] = useState({
    field: '',
    direction: '',
  });
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const params = {
    page,
    perPage,
    field: sort.field,
    sort: sort.direction,
    dates: [
      dayjs(dates[0])?.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      dayjs(dates[1])?.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    ],
  };

  const { data, isLoading, refetch } = useQuery({
    queryFn: async () => {
      const { data } = await instance.get(`admin/loyalty-history/${userID}`, {
        params,
      });
      return data;
    },
    queryKey: ['user-loyalty-history', userID, params],
    keepPreviousData: true,
    onError: error => {
      toastError(error);
    },
  });

  useEffect(() => {
    refetch();
  }, [dates[0], dates[1]]);

  const { data: userLevel } = useQuery({
    queryFn: async () => {
      const { data } = await instance.get(`admin/loyalty-level-user/${userID}`);
      return data;
    },
    queryKey: ['user-level', userID],
    onError: error => {
      toastError(error);
    },
  });

  const { data: userPoints } = useQuery({
    queryFn: async () => {
      const { data } = await instance.get(
        `admin/loyalty-points-user/${userID}`
      );
      return data;
    },
    queryKey: ['user-point', userID],
    onError: error => {
      toastError(error);
    },
  });

  return (
    <div className={styles.userPromotion}>
      <div className={styles.pointsDataWrapper}>
        <InputBar
          label={t('user_level')}
          name="level"
          value={userLevel?.name || t('level_missing')}
          disabled={true}
        />
        <InputBar
          label={t('total_points')}
          name="points"
          value={userPoints?.points || t('no_points')}
          disabled={true}
          classNameInputWrapper={styles.input}
        />
      </div>
      <UserPromotionFormBoard
        data={data?.data}
        pagination={{
          from: data?.from,
          to: data?.to,
          total: data?.total,
          lastPage: data?.last_page,
        }}
        dates={dates}
        setDates={setDates}
        isLoading={isLoading}
        sort={sort}
        setSort={setSort}
        page={page}
        setPage={setPage}
        perPage={perPage}
        setPerPage={setPerPage}
      />
    </div>
  );
};
